import {homeActions} from './home.actions';

export const initialState = {
  summary: null,
  isLoading: false,
  isSubmittingAction: false,
  error: null,
};

export function homeReducer(state = initialState, action) {
  switch (action.type) {
    case homeActions.LOAD_SUMMARY_REQUEST:
      return {...state, isLoading: true, error: null};
    case homeActions.LOAD_SUMMARY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        summary: (action.payload && action.payload.response) || null,
      };
    case homeActions.LOAD_SUMMARY_FAILURE:
      return {...state, isLoading: false, error: action.payload};

    case homeActions.APPLY_ACTION_REQUEST:
      return {...state, isSubmittingAction: true};
    case homeActions.APPLY_ACTION_SUCCESS:
      return {...state, isSubmittingAction: false};
    case homeActions.APPLY_ACTION_FAILURE:
      return {...state, isSubmittingAction: false, error: action.payload};

    default:
      return state;
  }
}
